var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audio-btn thinly-shadowed",class:_vm.playing ? 'playing-btn' : '',on:{"click":function($event){return _vm.controlSound(_vm.file)}}},[_c('p',[_vm._v(_vm._s(_vm.item))])])
}
var staticRenderFns = []

export { render, staticRenderFns }